"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _class, _temp2;

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n      //www.linkedin.com/shareArticle\n      ?mini=true\n      &url=%url\n      &title=%title\n      &summary=\n      &source=%url\n    "], ["\n      //www.linkedin.com/shareArticle\n      ?mini=true\n      &url=%url\n      &title=%title\n      &summary=\n      &source=%url\n    "]),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n            menubar=no,\n            toolbar=no,\n            resizable=yes,\n            scrollbars=yes,\n            height=", ",\n            width=", "\n          "], ["\n            menubar=no,\n            toolbar=no,\n            resizable=yes,\n            scrollbars=yes,\n            height=", ",\n            width=", "\n          "]); /**
                                                                                                                                                                                                                                                                                                                                                                                                                            * Copyright 2013-present, Novivia, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                            * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                            */

var _Button = require("react-bootstrap/Button");

var _Button2 = _interopRequireDefault(_Button);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require("react-fa/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _tempura = require("tempura");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Sharing platforms dictionary
var sharePlatforms = {
  email: {
    icon: "envelope-o",
    name: function name(_ref) {
      var __ = _ref.context.__;
      return __("contact::email");
    },
    style: "adn"
  },
  facebook: {
    height: 600,
    name: "Facebook",
    url: "//www.facebook.com/sharer/sharer.php?u=%url",
    width: 600
  },
  "google-plus": {
    height: 600,
    name: "Google+",
    url: "//plus.google.com/share?url=%url",
    width: 600
  },
  linkedin: {
    height: 600,
    name: "LinkedIn",
    url: (0, _tempura.noWhitespace)(_templateObject),
    width: 600
  },
  pinterest: {
    height: 300,
    name: "Pinterest",
    style: "google-plus",
    url: "//pinterest.com/pin/create/button/?url=%url",
    width: 600
  },
  reddit: {
    height: 800,
    name: "Reddit",
    url: "//www.reddit.com/submit?url=%url",
    width: 1000
  },
  twitter: {
    height: 300,
    name: "Twitter",
    url: "//twitter.com/home?status=%url",
    widht: 600
  }
};

/**
 * Social sharing button
 * @class
 */
var ShareButton = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ShareButton, _Component);

  function ShareButton() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ShareButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ShareButton.__proto__ || (0, _getPrototypeOf2.default)(ShareButton)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      title: _this.props.title,
      url: _this.props.url
    }, _this.handleShareOn = function (platform) {
      var _this$state = _this.state,
          title = _this$state.title,
          url = _this$state.url;


      switch (platform) {
        case "email":
          document.location.href = "mailto:?body=" + url;
          break;

        default:
          {
            var platformData = sharePlatforms[platform];

            var href = platformData.url.replace("%url", url).replace("%title", title);

            var _platformData$height = platformData.height,
                height = _platformData$height === undefined ? 800 : _platformData$height,
                _platformData$width = platformData.width,
                width = _platformData$width === undefined ? 600 : _platformData$width;


            window.open(href, "", (0, _tempura.noWhitespace)(_templateObject2, height, width));
            break;
          }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ShareButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        title: this.state.title || document.title,
        url: this.state.url || encodeURIComponent(window.location)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var type = this.props.type;
      var _sharePlatforms$type = sharePlatforms[type],
          _sharePlatforms$type$ = _sharePlatforms$type.icon,
          icon = _sharePlatforms$type$ === undefined ? type : _sharePlatforms$type$,
          _sharePlatforms$type$2 = _sharePlatforms$type.name,
          name = _sharePlatforms$type$2 === undefined ? type : _sharePlatforms$type$2,
          _sharePlatforms$type$3 = _sharePlatforms$type.style,
          style = _sharePlatforms$type$3 === undefined ? type : _sharePlatforms$type$3;


      var computedName = typeof name === "function" ? name(this) : name;

      return _react2.default.createElement(
        _Button2.default,
        {
          "aria-label": computedName,
          bsSize: "xsmall",
          className: (0, _classnames2.default)((0, _defineProperty3.default)({
            "btn-social-icon": true
          }, "btn-" + style, true)),
          onClick: function onClick() {
            return _this2.handleShareOn(_this2.props.type);
          }
        },
        _react2.default.createElement(_Icon2.default, { name: icon })
      );
    }
  }]);
  return ShareButton;
}(_react.Component), _class.propTypes = {
  // Title of the page to share.
  title: _propTypes2.default.string,

  // Type of the sharing method.
  type: _propTypes2.default.oneOf((0, _keys2.default)(sharePlatforms)).isRequired,

  // URL of the page to share.
  url: _propTypes2.default.string
}, _class.defaultProps = {
  title: "",
  url: ""
}, _class.contextTypes = {
  // Translation utility.
  __: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = ShareButton;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/react-components/ShareButton.jsx
// module id = 578
// module chunks = 15 19